import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialAdditionalDocApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import React from "react";
import { AdditionalDocApplication } from "../types/additionalDocTypes";
import { initialAdditionalDocDetail } from "./rudiAdditionalDocInitialValues";
import LibservAdditionalDocStepApplicant from "../views/components/services/additionalDoc/form/applicant/LibservAdditionalDocStepApplicant";
import LibservAdditionalDocStepDetails from "../views/components/services/additionalDoc/form/detail/LibservAdditionalDocStepDetails";
import LibservAdditionalDocStepDocuments from "../views/components/services/additionalDoc/form/documents/LibservAdditionalDocStepDocuments";
import LibservAdditionalDocStepFiling from "../views/components/services/additionalDoc/form/filing/LibservAdditionalDocStepFiling";

export const initialLibservAdditionalDocApplication: AdditionalDocApplication = {
  additionalDocDetail: initialAdditionalDocDetail,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialAdditionalDocApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <LibservAdditionalDocStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.additionalDoc.details",
      completed: false,
      component: <LibservAdditionalDocStepDetails />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <LibservAdditionalDocStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <LibservAdditionalDocStepFiling />,
      isEdited: false,
    },
  ],
};
